import { IdentitySyncRouteConfig } from '@/hooks/useIdentitySyncFailedNotifications/identitySyncRouteConfig.types';
import { IdentitySyncOperationType } from '@/ws';
import { invalidateEmployeeItemQueries, invalidateEmployeeListQueries } from '@/queries/employee';
import { invalidateCustomerItemQueries, invalidateCustomerListQueries } from '@/queries/customer';
import {
  invalidateOpoContactItemQueries,
  invalidateOpoContactListQueries,
  getCachedOpoContactUserId,
} from '@/queries/opo';

const EMPLOYEE_OPERATION_TYPES = [
  IdentitySyncOperationType.EmployeeModified,
  IdentitySyncOperationType.EmployeeEnabled,
  IdentitySyncOperationType.EmployeeDisabled,
];

const CUSTOMER_OPERATION_TYPES = [
  IdentitySyncOperationType.CustomerModified,
  IdentitySyncOperationType.CustomerEnabled,
  IdentitySyncOperationType.CustomerDisabled,
];

const OPO_CONTACT_OPERATION_TYPES = [IdentitySyncOperationType.OpoUserDataUpdated];

export const identitySyncConfig: IdentitySyncRouteConfig = {
  listRoutes: {
    '/admin/users/employees': {
      operationTypes: EMPLOYEE_OPERATION_TYPES,
      invalidate: invalidateEmployeeListQueries,
    },
    '/admin/users/contractors': {
      operationTypes: EMPLOYEE_OPERATION_TYPES,
      invalidate: invalidateEmployeeListQueries,
    },
    '/admin/customers/tx_users': {
      operationTypes: CUSTOMER_OPERATION_TYPES,
      invalidate: invalidateCustomerListQueries,
    },
    '/admin/opos/contacts': {
      operationTypes: OPO_CONTACT_OPERATION_TYPES,
      invalidate: invalidateOpoContactListQueries,
    },
  },
  detailRoutes: {
    '/admin/users/employees/:employeeId': {
      operationTypes: EMPLOYEE_OPERATION_TYPES,
      resolveViewedEntityId: (params) => params.employeeId,
      invalidate: (params) =>
        params.employeeId ? invalidateEmployeeItemQueries(params.employeeId) : Promise.resolve(),
    },
    '/admin/users/contractors/:employeeId': {
      operationTypes: EMPLOYEE_OPERATION_TYPES,
      resolveViewedEntityId: (params) => params.employeeId,
      invalidate: (params) =>
        params.employeeId ? invalidateEmployeeItemQueries(params.employeeId) : Promise.resolve(),
    },
    '/admin/customers/tx_users/:tx_usersId': {
      operationTypes: CUSTOMER_OPERATION_TYPES,
      resolveViewedEntityId: (params) => params.tx_usersId,
      invalidate: (params) =>
        params.tx_usersId ? invalidateCustomerItemQueries(params.tx_usersId) : Promise.resolve(),
    },
    '/admin/opos/contacts/:contactId': {
      operationTypes: OPO_CONTACT_OPERATION_TYPES,
      resolveViewedEntityId: (params) => (params.contactId ? getCachedOpoContactUserId(params.contactId) : undefined),
      invalidate: (params) =>
        params.contactId ? invalidateOpoContactItemQueries(params.contactId) : Promise.resolve(),
    },
  },
};
